export default __webpack_public_path__ + "static/media/destroy-white.4723f2ca.md";